import React from 'react';
import './CancellationInfo.scss';
import { FormattedMessage } from '../../localization';
import { useRootContext } from '../../providers/RootContext';

const CancellationInfo = ({ className }: { className?: string }) => {
  const { serviceName, localePortfolioUrl } = useRootContext();
  const serviceData = {
    movio: {
      cancelPath: 'unsubscribe/',
      customerCareEmail: 'help@moviotv.online'
    },
    xracademy: {
      cancelPath: 'unsubscribe-refund/',
      customerCareEmail: 'help@xracademy-gap.com'
    },
    entertainu: {
      cancelPath: 'unsubscribe/',
      customerCareEmail: 'help@portal.entertainu.tv'
    },
    funbox: {
      cancelPath: 'unsubscribe/',
      customerCareEmail: 'help@portal.funbox.net'
    }
  };

  const { cancelPath, customerCareEmail } = serviceData[serviceName];
  const cancelUrl = localePortfolioUrl + cancelPath;

  return (
    <div id="cancellation-info" className={`cancellation-info card ${className || ''}`}>
      <h4>
        <FormattedMessage id="cancelMembership" defaultMessage="Cancelling your membership" />
      </h4>
      <ul>
        <li>
          <span>
            <FormattedMessage id="option" defaultMessage="Option" />
            &nbsp;1:&nbsp;
          </span>
          <FormattedMessage id="option1" defaultMessage="Cancel your membership from here:" />
          &nbsp;
          <a href={cancelUrl} target="_blank">
            {cancelUrl}
          </a>
        </li>
        <li>
          <span>
            <FormattedMessage id="option" defaultMessage="Option" />
            &nbsp;2:&nbsp;
          </span>
          <FormattedMessage id="option2" defaultMessage="You can also call:" />
          <ul>
            <li>
              <FormattedMessage id="franceNo" defaultMessage="0805 98 54 98 (France)" />
            </li>
            <li>
              <FormattedMessage id="spainNo" defaultMessage="900 751 051 (Spain)" />
            </li>
            <li>
              <FormattedMessage id="italyNo" defaultMessage="800 785 693 (Italy)" />
            </li>
          </ul>
        </li>
        <li>
          <span>
            <FormattedMessage id="option" defaultMessage="Option" />
            &nbsp;3:&nbsp;
          </span>
          <FormattedMessage id="option3" defaultMessage="You can also send an email:" />
          &nbsp;
          <a href={`mailto:${customerCareEmail}`}>{customerCareEmail}</a>
        </li>
      </ul>
    </div>
  );
};

export default CancellationInfo;
